// @ts-nocheck
import React from "react";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

const GenericTransparentBtn = React.forwardRef(
  ({ style, children, onClick, onHover, disabled, ...rest }, ref) => {
    return (
      <Button
        ref={ref}
        {...rest}
        sx={{
          background: "transparent",
          padding: "0",
          minWidth: "0",
          border: "none",
          boxShadow: "none",
          cursor: "pointer",
          "&:hover": {
            background: "transparent",
            padding: "0",
            minWidth: "0",
            border: "none",
            boxShadow: "none",
            ...(style?.onHover || {})
          },
          ...(style || {})
        }}
        // onClick={e => {
        //   console.log(e, "GenericTransparentBtn");
        // }}
        onClick={onClick}
        onMouseEnter={(e) => {
          rest?.onMouseEnter?.(e);
          if (onHover) {
            onHover();
          }
        }}
        disabled={disabled || false}
      >
        {children}
      </Button>
    );
  }
);

GenericTransparentBtn.displayName = "GenericTransparentBtn";

GenericTransparentBtn.propTypes = {
  style: PropTypes.object,
  children: PropTypes.any,
  onClick: PropTypes.func,
  onHover: PropTypes.func
};

export default GenericTransparentBtn;